import React from 'react';
import GameQuery from '../../query/GameQuery';
import SalesTest from '../../components/SalesTest';
import { Route } from 'react-router-dom';
import { SALESTEST } from '../../routes';

const SalesTestRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={SALESTEST}
				render={props => <SalesTest {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default SalesTestRoute;
